import React from 'react';
import { SerializedStyles } from '@emotion/react';
import getConfig from 'next/config';
import { trackGuide } from '../../../../../../tracking/landing-page';
import * as defaultStyles from './guide-card.style';

interface GuideCardStyles {
  cardWrapper: SerializedStyles;
  imageWrapper: SerializedStyles;
  image: SerializedStyles;
  articleLink: SerializedStyles;
  articleInfo: SerializedStyles;
  title: SerializedStyles;
  subTitle: SerializedStyles;
}

interface GuideCardProps {
  title: string;
  subTitle: string;
  imageURL?: string;
  articleLink: string;
  styles?: GuideCardStyles;
}

const GuideCard = ({
  title,
  subTitle,
  imageURL = '',
  articleLink,
  styles = defaultStyles,
}: GuideCardProps): JSX.Element => {
  const { publicRuntimeConfig } = getConfig();
  const baseUrlWithProtocol = publicRuntimeConfig?.BASE_URL || '';

  return (
    <div css={styles.cardWrapper}>
      <a
        target="_blank"
        rel="noreferrer"
        css={styles.articleLink}
        href={`${baseUrlWithProtocol}${articleLink}`}
        onClick={() => trackGuide(title)}
      >
        <div css={styles.imageWrapper}>
          <img src={imageURL} css={styles.image} alt={subTitle} />
        </div>
        <div css={styles.articleInfo}>
          <p css={styles.title}>{title}</p>
          <p css={styles.subTitle}>{subTitle}</p>
        </div>
      </a>
    </div>
  );
};

export default GuideCard;
